<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>

         <v-row dense>
            <v-col cols="12" md="3" sm="6" v-for="report in reports" :key="report.id">
               <v-card class="annual-report-card" dark>
                  <v-img
                     v-if="thumbnailUrl(report)"
                     :src="thumbnailUrl(report)"
                     height="170"
                     cover
                  ></v-img>
                  <div v-else class="annual-report-placeholder">
                  </div>

                  <v-card-title class="subtitle-1 font-weight-bold">
                     {{ report.title }}
                  </v-card-title>
                  <v-card-text class="annual-report-description">
                     {{ plainDescription(report.description) }}
                  </v-card-text>
                  <v-card-actions>
                     <v-spacer></v-spacer>
                     <v-btn
                        v-if="reportUrl(report)"
                        icon
                        small
                        color="white"
                        :href="reportUrl(report)"
                        target="_blank"
                     >
                        <v-icon small>mdi-card-search</v-icon>
                     </v-btn>
                     <v-btn
                        v-if="reportUrl(report)"
                        icon
                        small
                        color="white"
                        :href="reportUrl(report)"
                        target="_blank"
                        :download="documentUrl(report) ? true : null"
                     >
                        <v-icon small>mdi-download</v-icon>
                     </v-btn>
                  </v-card-actions>
               </v-card>
            </v-col>

            <v-col cols="12" v-if="loading">
               <v-progress-linear indeterminate color="primary"></v-progress-linear>
            </v-col>

            <v-col cols="12" v-if="!loading && reports.length === 0">
               <v-alert type="info" outlined>No annual reports available.</v-alert>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'

export default {
   name: "MOMAnnualReports",

   props: ['user'],

   components: {
      DashboardLayout,
      BaseBreadcrumb,
   },

   data() {
      return {
         page: {
            title: "Annual Reports",
         },
         breadcrumbs: [
            {
               text: "Dashboard",
               disabled: false,
               to: "/dashboard",
            },
            {
               text: "Annual Reports",
               disabled: true,
            },
         ],
         loading: false,
         reports: [],
      }
   },

   mounted() {
      this.loadReports()
   },

   methods: {
      loadReports() {
         this.loading = true
         axios.get('/member/api/agm/reports')
         .then((resp) => {
            var rtn = resp.data
            if (rtn.status === 'OK') {
               this.reports = rtn.data || []
            } else {
               this.reports = []
            }
         })
         .catch(() => {
            this.reports = []
         })
         .finally(() => {
            this.loading = false
         })
      },

      documentUrl(item) {
         if (!item.document || !item.documentpath) {
            return null
         }
         return '/' + String(item.documentpath).replace(/^\/+|\/+$/g, '') + '/' + item.document
      },

      thumbnailUrl(item) {
         if (!item.thumbnail || !item.thumbnailpath) {
            return null
         }
         return '/' + String(item.thumbnailpath).replace(/^\/+|\/+$/g, '') + '/' + item.thumbnail
      },

      externalUrl(html) {
         if (!html) {
            return null
         }
         var match = String(html).match(/href=["']([^"']+)["']/i)
         return match ? match[1] : null
      },

      reportUrl(item) {
         return this.documentUrl(item) || this.externalUrl(item.description)
      },

      plainDescription(value) {
         if (!value) {
            return ''
         }
         var holder = document.createElement('div')
         holder.innerHTML = value
         return holder.textContent || holder.innerText || ''
      },
   },
};
</script>

<style scoped>
.annual-report-card {
   background: #174ea6;
   min-height: 275px;
}

.annual-report-placeholder {
   align-items: center;
   background: #174ea6;
   display: flex;
   height: 170px;
   justify-content: center;
}

.annual-report-description {
   color: #4fa3ff;
   min-height: 50px;
   word-break: break-word;
}
</style>
